import React from 'react'
import TextField from '../../../baseApp/shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';

const OpenSpaceSubForm = ({
    viewMode,
    capacity,
    handleOnFieldBlur,
    handleFieldChange,
}) => {
    return <div id="open-spaces-sub-form" className="field-row">
        <div className="row">
            <TextField
                value={capacity.value}
                error={capacity.error}
                label={I18n.t("subForms.field.capacity")}
                handleFieldChange={value => handleFieldChange("capacity", value)}
                themeName="form"
                disabled={viewMode}
                width={4}
            />
        </div>
    </div>
};

export default OpenSpaceSubForm;